export default () => ({
  canUndo: false,
  canRedo: false,
  isChanging: false,
})
